import React, {Component, Fragment} from 'react';
import {autobind} from 'core-decorators';
import {graphql, compose} from 'react-apollo';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx/xlsx.mjs';
import createAttendee from 'graphql/mutations/orders/create-attendee.gql';
import importAttendees from 'graphql/mutations/orders/import-attendees.gql';

import userQuery from 'graphql/queries/user.gql';
import {Form, Field, Input} from 'components/forms';
import Button from 'components/button';
import Spinner from 'components/spinner';
import styles from './styles.css';

@compose(
    graphql(userQuery, {name: 'userData'}),
    graphql(createAttendee, {
        props: ({mutate}) => ({
            onSubmit: variables => mutate({variables}),
        }),
    }),
    graphql(importAttendees, {
        props: ({mutate}) => ({
            importAttendees: variables => mutate({variables}),
        }),
    }),
)
@autobind
export default class AttendeeForm extends Component {
    static propTypes = {
        orderId: PropTypes.number.isRequired,
        orderDataQuery: PropTypes.any,
    };

    state = {
        importAlert: 'el formato del excel es incorrecto, por favor descargue el excel de ejemplo en la seccion de formulario',
    }

    checkXLSXheaders(headersData, checkHeaders) {
        return JSON.stringify(Object.values(headersData[0])).toLowerCase() === JSON.stringify(checkHeaders).toLowerCase();
    }

    handleOnChange(e) {
        this.setState({errors: ''});
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = event.target.result;
            const checkHeaders = ['nombre', 'apellido', 'razon social', 'cuit'];
            const workBook = XLSX.read(data, {type: 'binary'});
            const workSheet = workBook.Sheets[workBook.SheetNames[0]];
            const fileData = XLSX.utils.sheet_to_json(
                workSheet,
                {header: ['firstName', 'lastName', 'legalName', 'cuit']},
            );
            const headersData = Array(fileData[0]).map(({__rowNum__, ...item}) => item);
            fileData.splice(0, 1);

            if (!(this.checkXLSXheaders(headersData, checkHeaders))) return alert(this.state.importAlert);

            const parsedFileData = fileData.map(({__rowNum__, ...item}) => item);
            parsedFileData.forEach(item => {
                if (typeof item.cuit !== 'string') {
                    this.setState({
                        errors: 'Error: CUIT debe estar con formato de texto, no de numero',
                        parsedFileData: null,
                    });
                    return;
                }
                item.cuit = item.cuit.replace(/\D/g, '');
            });
            this.setState({parsedFileData});
            this.handleImportAttendees();
        };
        reader.readAsBinaryString(file);
    }

    async handleImportAttendees() {
        this.setState({loading: true, errors: undefined});
        const response = await this.props.importAttendees({
            attendees: this.state.parsedFileData,
            order: this.props.orderId,
        });
        if (response.data.importAttendees.errors) {
            this.setState({
                loading: false,
                errors: response.data.importAttendees.errors,
            });
        } else {
            this.setState({
                loading: false,
                orderId: response.data.importAttendees.order.id,
            });
            this.props.orderDataQuery.refetch();
        }
    }

    handleExampleExport() {
        const headers = [{
            Nombre: '',
            Apellido: '',
            'Razon social': '',
            CUIT: '',
        }];
        const attendeeDataJson = JSON.parse(JSON.stringify(headers));
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(attendeeDataJson);
        XLSX.utils.book_append_sheet(wb, ws, 'invitados');
        XLSX.writeFile(wb, 'invitados_ejemplo.xlsx');
    }

    handleExportHover(exportHover) {
        return () => this.setState({exportHover});
    }

    handleDownloadHover(downloadHover) {
        return () => this.setState({downloadHover});
    }

    async handleSubmit(values) {
        this.setState({loading: true, errors: undefined});
        const response = await this.props.onSubmit({
            ...values,
            order: this.props.orderId,
        });
        if (response.data.createAttendee.errors) {
            this.setState({
                loading: false,
                errors: response.data.createAttendee.errors,
            });
        } else {
            this.setState({
                loading: false,
                orderId: response.data.createAttendee.order.id,
            });
            this.props.orderDataQuery.refetch();
        }
    }

    render() {
        if (this.state.loading === true) return <Spinner />;

        return (
            <div className={styles.root}>
                <div className={styles.cardHeader}>Formulario de carga de invitados
                    <span className={styles.helpText}>(completar los datos de los invitados antes de subir la factura)</span>
                </div>
                <div className={classNames(styles.cardBody, styles.cardBodyRefund)}>
                    <Form
                        fields={[
                            {key: 'firstName', initial: ''},
                            {key: 'lastName', initial: ''},
                            {key: 'legalName', initial: ''},
                            {key: 'cuit', initial: ''},
                        ]}
                        loading={this.state.loading}
                        errors={this.state.errors}
                        onSubmit={this.handleSubmit}>
                        {({getFieldProps, renderErrors, isValid}) => (
                            <div className={styles.fields}>
                                <Fragment>
                                    <Field label='Nombre'>
                                        <Input type='text' {...getFieldProps('firstName')} />
                                        {renderErrors('firstName')}
                                    </Field>
                                    <Field label='Apellido'>
                                        <Input type='text' {...getFieldProps('lastName')} />
                                        {renderErrors('lastName')}
                                    </Field>
                                    <Field label='Razón social'>
                                        <Input type='text' {...getFieldProps('legalName')} />
                                        {renderErrors('legalName')}
                                    </Field>
                                    <Field label='CUIT'>
                                        <Input type='number' {...getFieldProps('cuit')} />
                                        {renderErrors('cuit')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        {renderErrors('vacancie')}
                                        <Button theme='yellow' disabled={!isValid() || this.state.loading}>
                                            {this.state.loading ? 'GUARDANDO...' : 'GUARDAR'}
                                        </Button>
                                        <div
                                            onMouseEnter={this.handleExportHover(true)}
                                            onMouseLeave={this.handleExportHover(false)}
                                            className={classNames(styles.input, {
                                                [styles.disabled]: this.props.exportDisabled,
                                                [styles.exportHover]: this.state.exportHover,
                                            })}>
                                            <div className={styles.browse}>
                                                IMPORTAR EXCEL
                                            </div>
                                            <input
                                                type='file'
                                                className={styles.root}
                                                onChange={e => this.handleOnChange(e)} />
                                        </div>
                                        <div
                                            onMouseEnter={this.handleDownloadHover(true)}
                                            onMouseLeave={this.handleDownloadHover(false)}
                                            onClick={() => this.handleExampleExport()}
                                            className={classNames(styles.input, {
                                                [styles.disabled]: this.props.downloadDisabled,
                                                [styles.exportHover]: this.state.downloadHover,
                                            })}>
                                            <div className={styles.browse}>
                                                DESCARGAR EJEMPLO
                                            </div>
                                        </div>
                                    </Form.Actions>
                                </Fragment>
                            </div>
                        )}
                    </Form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-detail/attendee-form/index.js